import { ReactNode } from "react";
import { cardVariants } from "../../../variants";
import { motion } from "framer-motion";

export default function CardMultiSectionContainer({ 
    children,
    cardWidth, 
    cardHeight,
    cardMargin="mt-5", 
    cardPadding="py-5 px-2 2xl:px-5",
    cardGap="gap-1 xl:gap-4 2xl:gap-[1.1vw]",
    onClick,
    classes=""
}: { 
    children?: ReactNode;
    cardWidth?: string | false; 
    cardHeight?: string | false;
    cardMargin?: string;
    cardPadding?: string;
    cardGap?: string;
    onClick?: () => void | undefined;
    classes?: string;
}) {

    return (
         <motion.article
            variants={cardVariants}
            onClick={onClick}
            className={`
                flex flex-col ${cardGap} ${!cardWidth && "py-[1.5vw]"} justify-center items-center
                rounded-tr-4xl 2xl:rounded-tr-[2.5vw] rounded-bl-4xl 2xl:rounded-bl-[2.5vw] overflow-hidden 
                s1hsadow-[0_0_52px_12px_#f6f6f6]
                card-multi-section text-black 
                ${cardMargin} ${cardPadding} ${onClick !== undefined ? "NOcursor-pointer" : "NOcursor-default"}
                ${classes}
                w-2/3 sm:w-[28vw] md:w-[25vw] 2xl:w-[25vw] h-fit 
                `}
            {...(cardWidth && cardHeight 
                ? { style:{ width: cardWidth, height: cardHeight, willChange: "transform, opacity", } }
                : { style: { willChange: "transform, opacity", },} 
            )}
        >
            {children}
        </motion.article>
    )
}
